module.exports = __webpack_public_path__ + "img/side-entrance.059e5a5c.webp";